export default [
    {
        name: 'TMoaAll',
        path: 'TMoaAll',
        component: () => import('@/pages/BigData/TrademarkModule/TMAnsReexCaseFiling/TMoaAll'),
        meta: { title: '全部' },
        props(route) {
            return {
                id: route.query.id
            }
        },
    },
    {
        name: 'TMoaToBeDeclared',
        path: 'TMoaToBeDeclared',
        component: () => import('@/pages/BigData/TrademarkModule/TMAnsReexCaseFiling/TMoaToBeDeclared'),
        meta: { title: '待申报' },
        props(route) {
            return {
                id: route.query.id
            }
        },
    },
    {
        name: 'TMoaDeclaring',
        path: 'TMoaDeclaring',
        component: () => import('@/pages/BigData/TrademarkModule/TMAnsReexCaseFiling/TMoaDeclaring'),
        meta: { title: '申报中' },
        props(route) {
            return {
                id: route.query.id
            }
        },
    },
    {
        name: 'TMoaDeclared',
        path: 'TMoaDeclared',
        component: () => import('@/pages/BigData/TrademarkModule/TMAnsReexCaseFiling/TMoaDeclared'),
        meta: { title: '已申报' },
        props(route) {
            return {
                id: route.query.id
            }
        },
    },
    {
        name: 'TMoaDetails',
        path: 'TMoaDetails',
        redirect:{name:'tmoaShenBaoCaiLiao'},
        component: () => import('@/pages/BigData/TrademarkModule/TMoaDetails'),
        meta: { title: '详情' },
        props(route) {
            return {
                id: route.query.id
            }
        },
        children: [
            {
                name: 'tmoaShenBaoCaiLiao',
                path: 'tmoaShenBaoCaiLiao',
                component: () => import('@/pages/BigData/TrademarkModule/TMoaDetails/tmoaShenBaoCaiLiao'),
                meta: { title: '申报材料' },
                props(route) {
                    return {
                        id: route.query.id
                    }
                },
            },
            {
                name: 'tmoaTongZhiWenShu',
                path: 'tmoaTongZhiWenShu',
                component: () => import('@/pages/BigData/TrademarkModule/TMoaDetails/tmoaTongZhiWenShu'),
                meta: { title: '通知文书' },
                props(route) {
                    return {
                        id: route.query.id
                    }
                },
            },
        ]
    },
]